<!-- Кнопка перехода в раздел приложения на главной странице. -->
<template>
  <HomeQuickActionCard
    :label="item.label"
    :color="item.color"
    :icon-name="item.iconName"
    @click="$emit('click')"
  />
</template>

<script>
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";

export default {
  name: "HomeNavigationAction",

  components: {
    HomeQuickActionCard,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  emits: ["click"],
};
</script>
